$(function() {

    // Save existing sort parameters
    Shopify.queryParams = {};
    if (location.search.length) {
        for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }

    // Add existing sort parameters to current URL
    var sortBy = document.querySelector('#SortBy')
    if (sortBy) {
        sortBy.addEventListener('change', function(e) {
            var value = e.currentTarget.value;
            Shopify.queryParams.sort_by = value;
            location.search = new URLSearchParams(Shopify.queryParams).toString();
        });
    }

    // Add existing sort parameters to current URL
    var productNo = document.querySelector('#ProductNo')
    if (productNo) {
        productNo.addEventListener('change', function(e) {
            var value = e.currentTarget.value;
            Shopify.queryParams.view = value;
            location.search = new URLSearchParams(Shopify.queryParams).toString();
        });
    }

    const MAX_QTY = parseInt($('[data-qty-max]').val())

    $('[data-qty-decrease]').on('click', function(e){
        e.preventDefault()
        const input = $('[data-qty]')
        var value = input.val();
        if (value > 1) {
            value--;
        }
        input.val(value);
    })

    $('[data-qty-increase]').on('click', function(e){
        e.preventDefault()
        const input = $('[data-qty]')
        var value = input.val();
        if (value != MAX_QTY) {
            value++;
            input.val(value);
        }
    })

    // Toggle the filter position
    let $filterToggle = $('[data-toggle-filter]')
    let $filterContainer = $('#boost-pfs-filter-tree')
    $filterToggle.on('click', function(e) {
        e.preventDefault()
        $filterContainer.addClass('boost-pfs-filter-tree-mobile-open')
        $('body').addClass('filter--open')
    })

    $('input[type="search"]').on('keyup', function(){
        let length = $(this).val().length
        if (length > 0) {
            $('[data-search-icon]').addClass('hidden')
        } else {
            $('[data-search-icon]').removeClass('hidden')
        }
    })

    $('input[type="search"]').on('click', function(){
        let length = $(this).val().length
        // console.log(length)
    })

    $('[data-clear-filter]').on('click', function(e){
        e.preventDefault()
        window.location = window.location.href.split('?')[0];
    })

    // Remove overlay on submit of filter
    let $filterSubmit = $('.boost-pfs-filter-mobile-footer')
    $('body').on('click', '.boost-pfs-filter-show-result', function(e) {
        $('body').removeClass('filter--open')
    })

    // Allow clicking of outside the filter
    $('body').on('click', function (e) {
        if ($(e.target).closest('.boost-pfs-filter-options-wrapper').length === 0 && 
            $(e.target).closest('.surefire-filter-button').length === 0) {
                $filterContainer.removeClass('boost-pfs-filter-tree-mobile-open')
                $('body').removeClass('filter--open')
        }
    });

    if (typeof FilterResult != "undefined") {    
        // Optional callback see 
        // @link https://help.boostcommerce.net/article/465-how-to-customize-product-item-on-collection-page-app-lib-v2#a2
        FilterResult.prototype.afterRender = function() {
            let params = theme.helpers.getAllUrlParams(window.location.href)
            let filterActive = Object.keys(params).some(function(k){ return ~k.indexOf("pf_") });
            if (filterActive) {
                $('[data-clear-filter]').removeClass('hidden')
                $('[data-toggle-filter]').removeClass('is--inactive')
            } else {
                $('[data-clear-filter]').addClass('hidden')
                $('[data-toggle-filter]').addClass('is--inactive')
            }
        }
    }

    $('#predictive-search').css({
        'margin-top': $('header.header').height()
    })

})